"use strict";

define('rs/errors',['rs/helper'], function (helper) {
  function createErrorType(name, defaultMessage, InheritClass) {
    function SubError(message) {
      if (!(this instanceof SubError)) {
        return new SubError(message);
      }
      if (InheritClass) {
        InheritClass.apply(this, arguments);
      }
      this.message = typeof message === "string" ? message : defaultMessage;
      this.name = name;
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
      }
    }
    helper.inherit(SubError, InheritClass || Error);
    return SubError;
  }
  ;
  function ValidationError(response) {
    if (!(this instanceof ValidationError)) {
      return new this(response);
    }
    this.validation = response.validation;
  }
  ;
  helper.inherit(ValidationError, Error);
  ValidationError.prototype.getValidation = function () {
    return this.validation;
  };
  function HTTPError(response) {
    if (!(this instanceof HTTPError)) {
      return new this(response);
    }
    if (response instanceof HTTPError) {
      this.serverResponse = response.serverResponse;
      this.message = response.message;
    } else {
      this.serverResponse = response;
      this.message = response && response.error && response.error.message;
    }
    if (!this.message) {
      switch (this.getCode()) {
        default:
          this.message = "A problem has occured communicating with the server.";
          break;
      }
    }
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
  helper.inherit(HTTPError, Error);
  HTTPError.prototype.getCode = function () {
    var resp = this.serverResponse;
    if (resp && resp.error && resp.error.code) {
      return resp.error.code;
    }
    return -1;
  };
  HTTPError.prototype.getServerMessage = function () {
    var resp = this.serverResponse;
    if (resp && resp.error) {
      return resp.error.message || '';
    }
    return '';
  };
  var IgnoredError = createErrorType('IgnoredError', '');
  var RSErrors = {
    createErrorType: createErrorType,
    ModalCancel: createErrorType('ModalCancel', 'canceling the modal'),
    HTTPError: HTTPError,
    APIError: createErrorType('APIError', '', HTTPError),
    NoSessionError: createErrorType('NoSessionError', '', IgnoredError),
    NavigationCancelled: createErrorType('NavigationCancelled', ''),
    InsufficientPermissions: createErrorType('InsufficientPermissions', 'You have insufficient permissions to access this resource.'),
    IgnoredError: IgnoredError,
    InvalidSubmissionTemplate: createErrorType('InvalidSubmissionTemplate', 'The template for this resource is invalid.'),
    DomainIsLocked: createErrorType('DomainIsLocked', ''),
    ValidationError: ValidationError
  };
  RSErrors.UploadAPIError = createErrorType('UploadAPIError', '', RSErrors.APIError);
  return RSErrors;
});

